import * as React from 'react';
import { fDateTime } from '../../utils/formatTime';
import {
  CheckCircle2, FileText, Pencil, Clock, UserPlus, XCircle,
  PlusCircle, Ban, RotateCcw, Tag, FilePlus
} from 'lucide-react';

const ACTION_CONFIG = {
  criacao:              { label: 'Chamado criado',       icon: PlusCircle,    color: 'text-[#007A5A] bg-[#E8F5E9] dark:bg-[#1A3D2A]' },
  aceitar_chamado:      { label: 'Chamado aceito',       icon: CheckCircle2,  color: 'text-[#007A5A] bg-[#E8F5E9] dark:bg-[#1A3D2A]' },
  editar_completado:    { label: 'Chamado finalizado',   icon: CheckCircle2,  color: 'text-[#007A5A] bg-[#E8F5E9] dark:bg-[#1A3D2A]' },
  cancelar_chamado:     { label: 'Chamado cancelado',    icon: Ban,           color: 'text-[#D72C0D] bg-[#FFF4F4] dark:bg-[#3D1515]' },
  recusar_chamado:      { label: 'Chamado recusado',     icon: XCircle,       color: 'text-[#D72C0D] bg-[#FFF4F4] dark:bg-[#3D1515]' },
  editar_estimativa:    { label: 'Estimativa editada',   icon: Clock,         color: 'text-[#1264A3] bg-[#EDF5FA] dark:bg-[#15293D]' },
  editar_descricao:     { label: 'Descrição editada',    icon: Pencil,        color: 'text-[#1264A3] bg-[#EDF5FA] dark:bg-[#15293D]' },
  editar_titulo:        { label: 'Título alterado',      icon: Tag,           color: 'text-[#1264A3] bg-[#EDF5FA] dark:bg-[#15293D]' },
  editar_status:        { label: 'Status alterado',      icon: RotateCcw,     color: 'text-[#1264A3] bg-[#EDF5FA] dark:bg-[#15293D]' },
  editar_copiado_para:  { label: 'Em cópia editado',     icon: UserPlus,      color: 'text-[#1264A3] bg-[#EDF5FA] dark:bg-[#15293D]' },
  editar_arquivos:      { label: 'Arquivo editado',      icon: FileText,      color: 'text-[#B98900] bg-[#FFF8E6] dark:bg-[#3D3215]' },
  add_arquivos:         { label: 'Arquivo inserido',     icon: FilePlus,      color: 'text-[#B98900] bg-[#FFF8E6] dark:bg-[#3D3215]' },
};

function getActionConfig(action) {
  return ACTION_CONFIG[action] || { label: action, icon: PlusCircle, color: 'text-[#616061] bg-[#F8F8F8] dark:bg-[#2C2C2C]' };
}

export default function TimelinePadrao({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-[#616061] dark:text-[#ABABAD]">
        <div className="w-14 h-14 rounded-xl bg-[#F8F8F8] dark:bg-[#222529] flex items-center justify-center mb-3">
          <Clock className="w-7 h-7 text-[#1264A3]" />
        </div>
        <p className="text-[15px] font-bold text-[#1D1C1D] dark:text-[#D1D2D3]">Nenhum histórico</p>
        <p className="text-[13px] text-[#616061] dark:text-[#ABABAD] mt-1">As ações aparecerão aqui</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {data.map((option, index) => {
        const config = getActionConfig(option.action);
        const Icon = config.icon;
        const isLast = index === data.length - 1;

        return (
          <div key={index} className="flex gap-3 group">
            {/* Timeline rail */}
            <div className="flex flex-col items-center flex-shrink-0 w-8">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${config.color}`}>
                <Icon className="w-4 h-4" />
              </div>
              {!isLast && (
                <div className="w-px flex-1 bg-[#E0E0E0] dark:bg-[#383838] my-1" />
              )}
            </div>

            {/* Content */}
            <div className={`flex-1 pb-5 ${isLast ? '' : ''}`}>
              <div className="flex items-baseline gap-2 min-h-[32px] pt-1">
                <span className="text-[13px] font-bold text-[#1D1C1D] dark:text-[#D1D2D3]">
                  {config.label}
                </span>
                <span className="text-[12px] text-[#616061] dark:text-[#ABABAD]">
                  {fDateTime(option.date)}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
